// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4209356f","879":"3a508f52"}[chunkId] + ".chunk.js";
};